module.exports = __webpack_public_path__ + "img/0Q3A7268_L_WoodMatted_MockedUp.ab3825a0.jpg";